import React from "react";
import styles from "./modal-layout.module.scss";

const ModalLayout = ({
  modalOpen,
  children,
  onClickOut,
}: {
  modalOpen: boolean;
  children: React.ReactNode;
  onClickOut?: () => void;
}) => {
  return (
    <>
      {modalOpen === true && (
        <div
          className={styles.backdrop}
          onClick={() => (onClickOut ? onClickOut() : undefined)}
        >
          <div
            style={{
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {children}
          </div>
        </div>
      )}
    </>
  );
};

export default ModalLayout;
